import type { startseite } from "@progressive-development/politik-model";

/**
 * Das Nachschlagen in der kuratierten Parteien-Tabelle — an EINER Stelle.
 *
 * Farbe und Kurzname zu einem Slug standen vorher in sieben Bauteilen als
 * `this.parteien.find(…)`, und zwei davon hatten bereits verschiedene
 * Rückfallfarben für „ohne Eintrag". Hier gibt es genau eine Antwort.
 *
 * Aufgelöst wird ausschließlich über den Slug, nie über einen Namen. Ohne
 * Eintrag: der neutrale Datenton der Palette (Farbe identifiziert, sie
 * wertet nicht — und geraten wird nicht) bzw. der Slug selbst (sichtbar
 * durchgereicht, nicht verschluckt).
 */

/** Der neutrale Datenton für Wahlvorschläge ohne kuratierten Eintrag. */
export const FARBE_OHNE_EINTRAG = "var(--portal-daten-45)";

export function partei(
  parteien: readonly startseite.ParteiEintrag[] | undefined,
  slug: string | undefined,
): startseite.ParteiEintrag | undefined {
  return slug ? parteien?.find((p) => p.id === slug) : undefined;
}

/** Darstellungsfarbe; ohne Eintrag der neutrale Datenton. */
export function parteiFarbe(
  parteien: readonly startseite.ParteiEintrag[] | undefined,
  slug: string | undefined,
): string {
  return partei(parteien, slug)?.farbe ?? FARBE_OHNE_EINTRAG;
}

/** Kurzname; ohne Eintrag der Slug — nie eine Umschrift. */
export function parteiKurzname(
  parteien: readonly startseite.ParteiEintrag[] | undefined,
  slug: string,
): string {
  return partei(parteien, slug)?.kurzname ?? slug;
}
